import store from './store'

$.ajax({
  url: 'https://paredimcommunities.com/specials/wp-json/wp/v2/community?per_page=100',
  method: 'GET'
})
.then((res) => {
  store.wpResponse = res
})


// WEBPACK FOOTER //
// ./src/assets/js/buildStore.js